import { UserSessionDataForm } from "./login/user-session-data-form";
import { ProjectDataForm } from "./project-data-form";
import { SessionActivityDataForm } from "./session-activity-data-form";


export class PatentSearchDataForm {

	patentSearchId: number;
	inventionBrief: String;
	inventionFeatures: String;
	keywords: String;
	searchStrategy: String;
	listClasses: String;
	formStrategy: String;
	closerReference: String;
	patentSearchDocuments: string;
	userSessionDataForm: UserSessionDataForm;
	projectDataForm: ProjectDataForm;
	sessionActivityDataForm : SessionActivityDataForm
}
